
<!-- app.component.html -->

<app-app-header></app-app-header>
<router-outlet (activate)="onActivate($event)"/>
<!-- Other content of your site goes here -->

<app-app-footer></app-app-footer>
